import 'jquery';
import $ from "jquery";
import Promise from 'promise';
import isTouchDev from './isTouchDev';

/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */

class GoogleMapAPI {

    constructor(dom, options) {
        this.dom = dom;
        this.options = options;
        this.marks = [];
        this.markers = [];
        this.infoWindows = [];
    }

    initialize() {
        const { centerCoords, zoom } = this.options;
        const center = new google.maps.LatLng(centerCoords.lat, centerCoords.lng);
        const initOptions = {
            center,
            zoom,
        };
        this.map = new google.maps.Map(this.dom, initOptions);
    }

    setMarks(marks) {
        this.marks = marks;
    }

    drawMarker(mark){
        const markImage = {
            url: location.origin + '/wp-content/themes/murberget/resources/assets/images/mark-default.png',
            anchor: new google.maps.Point(16, 32),
        };

        const markImageHover = {
            url: window.ajaxurl + '/wp-content/themes/murberget/resources/assets/images/mark-hovered.png',
            anchor: new google.maps.Point(16, 32),
        };

        const { id, coords, content } = mark;

        let marker = new google.maps.Marker({
            icon: markImage,
            position: new google.maps.LatLng(coords.lat, coords.lng),
            map: this.map,
        });

        let infowindow = new google.maps.InfoWindow({
            content: content,
            pixelOffset: new google.maps.Size(0,10),
        });

        this.markers = [...this.markers, marker];
        this.infoWindows = [...this.infoWindows, infowindow];

        let isInfoHovered = false;

        const showInfoWindow = () => {
            // close all others
            if(!isTouchDev()) {
                this.markers.forEach(marker => {
                    marker.setIcon(markImage);
                });
                marker.setIcon(markImageHover);
            }
            this.infoWindows.forEach(infoWindow => {
                infoWindow.close();
            });
            // open info window
            infowindow.open(this.map,marker);
            // set infoWindow container
            let $infoContainer = $('.js-click-title[data-id="' + id + '"]').parent().parent().parent().parent();
            $infoContainer.addClass('info-window js-info-window');
            $infoContainer.attr('data-id',id);

            if(isTouchDev()) {
                const $closeButton = $infoContainer.find('.gm-style-iw').next();
                $closeButton.addClass('close-button').find('img').hide();
                $closeButton.append('<i class="fa fa-times"></i>');
            }
        };

        const closeInfoWindow = () => {
            // close all others
            this.markers.forEach(marker => {
                marker.setIcon(markImage);
            });
            this.infoWindows.forEach(infoWindow => {
                infoWindow.close();
            })
        };

        google.maps.event.addListener(marker, 'mouseover', function() {
            showInfoWindow();
        });

        google.maps.event.addListener(marker, 'mouseout', function() {
            setTimeout(()=>{
                if(!isInfoHovered) {
                    isInfoHovered = false;
                    closeInfoWindow();
                }
            },0)
        });

        google.maps.event.addListener(marker, 'click', function() {
            if(isTouchDev()) {
                showInfoWindow();
            } else {
                const $previewBox = $('.js-box-preview');
                $previewBox.empty();
                const {title, excerpt, id} = mark;
                const $previewHtml = `<h2 class="title">${title}</h2>
                                  <p class="text-el">${excerpt}</p>
                                  <div class="read_more_loction">
                                     <a class="js-click-read-more" data-id="${id}'" href="#">
                                        Mer om ${title}
                                     </a>
                                  </div>`;
                $previewBox.append($previewHtml);
                correctMapSectionHeight()
            }

            if($(window).width() <= 1024 && $(window).width() > 768) {
                $('.map-wrapper .left-section').css('height', 'auto');
                setTimeout(function () {
                    $('.map-wrapper .left-section').css('height',$('.map-wrapper .left-section').height());
                }, 100);
            }

        });

        $('body').on('mouseover','.js-info-window[data-id="' + id + '"]',function() {
            if (!isInfoHovered && !isTouchDev()) {
                isInfoHovered = true;
                showInfoWindow();
            }
        });

        $('body').on('mouseleave','.js-info-window[data-id="' + id + '"]',function() {
            if (isInfoHovered && !isTouchDev()) {
                isInfoHovered = false;
                closeInfoWindow();
            }
        });
    }

    clearMarkers() {
        this.markers.forEach(marker => {
            marker.setMap(null);
        });
        this.markers = [];
    }

    fitMapToMarks() {   
        const bounds = new google.maps.LatLngBounds();
        for (let i = 0; i < this.markers.length; i++) {
            bounds.extend(this.markers[i].getPosition());
        }
        this.map.fitBounds(bounds);
        const $thisMap = this.map;
        const listener = google.maps.event.addListener(this.map,"idle", function() {   
            if ($thisMap.getZoom() > 10) $thisMap.setZoom(10);
            google.maps.event.removeListener(listener);
        });
    }
}

const correctMapSectionHeight = () => {
    if($(window).width() >= 1024) {
        $('.js-home-map-section-wrapper').css('height', $('.map-wrapper .left-section').height());
    }
};

class MarkInfoPopup {
    constructor ($homeSectionWrapper) {
        this.wrapper = $homeSectionWrapper;
        this.isFetching = false;
    }

    open(id) {
        const $popupHtml = `<div class="mark-popup js-mark-popup">
                                <div class="mark-popup-wrapper clearfix js-mark-popup-wrapper">
                                    <div class="mark-popup-content js-mark-popup-content">
                                        <h2></h2>
                                        <div></div>
                                    </div>
                                    <button class="js-close-mark-popup-button close-mark-popup-button">
                                        <span>STÄNG</span><i class="fa fa-close"></i>
                                    </button>
                                </div>
                            </div>`;
        this.wrapper.append($popupHtml);

        this._getMuseumPost(id);
    }

    close () {
        this.wrapper.find('.js-mark-popup').remove();
    }

    _getMuseumPost(id) {
        this.isFetching = true;
        this._showLoader();
        $.ajax({
            type : "GET",
            dataType : "json",
            url: window.ajaxurl,
            data: ({action: 'museum_post_action', post_id: id}),
            success: (res)=>{
                this.isFetching = false;
                this._hideLoader();
                if(res.success) {
                    this._parseMuseumPost(res.post)
                } else {
                    this.close();
                }
            },
            error: (error) => {
                console.error(error);
                this.isFetching = false;
                this._hideLoader();
                this.close();
            },
        });
    }

    _showLoader() {
        const $loaderHtml = `<div class="mark-popup-loader js-mark-popup-loader"><span>Loading...</span></div>`;
        this.wrapper.append($loaderHtml);
    }

    _hideLoader() {
        this.wrapper.find('.js-mark-popup-loader').remove();
    }

    _parseMuseumPost(post) {
        const { post_title, content, images, permailnk } = post;
        this.wrapper.find('.js-mark-popup-content > h2').text(post_title);
        this.wrapper.find('.js-mark-popup-content > div').html(content);
        if(images.length) {
            this.wrapper.find('.js-mark-popup-wrapper').append('<ul class="mark-popup-images js-mark-popup-images"></ul>');
            images.forEach((image,index)=>{
                const $imageHtml = `<li><img src="${image}" alt="${post_title} additional picture ${index + 1}"></li>`;
                this.wrapper.find('.js-mark-popup-images').append($imageHtml);
            });
            this.wrapper.find('.js-mark-popup-images').addClass('pull-left');
            this.wrapper.find('.js-mark-popup-content').addClass('pull-right');
        }
    }
}

class SelectMuseumType {
    constructor ($museumTypesWrapper) {
        this.wrapper = $museumTypesWrapper;
        this.types = [];
        this.activeType = null;
    }

    init(types) {
        this.types = types;
        this.setActiveType(this.types[0]);
    }

    setActiveType(type) {
        this.activeType = type;
        this.wrapper.find('a').removeClass('active');
        this.wrapper.find('a[data-slug=' + this.activeType + ']').addClass('active');
    }
}

export default () => {
    const $previewBox = $('.js-box-preview');
    const $homeSectionWrapper = $('.js-home-map-section-wrapper');
    const $museumTypesWrapper = $('.js-museum-types');
    const homeMarkInfoPopup = new MarkInfoPopup($homeSectionWrapper);
    const selectMuseumType = new SelectMuseumType($museumTypesWrapper);

    // main init function
    const initHomeMap = () => {
        const dom = document.getElementById("map");
        //ToDo: get default center coordinates (from admin?)
        const options = {
            centerCoords: {
                lat:62.84750562425423,
                lng:17.470605999999975,
            },
            zoom:8,
        };
        const homePageMap = new GoogleMapAPI(dom,options);

        // init google map with default options
        homePageMap.initialize();

        // init marks
        Promise.all([getMapMarks(),getMarksTypes()]).then(
            result =>  {
                // store all marks
                homePageMap.setMarks(result[0]);
                // store all types
                selectMuseumType.init(result[1]);
                // draw marks of active type
                selectType(selectMuseumType.activeType);                
            },
            error => {
                console.error(error)
            }
        );

        $('body').on('click','.js-type-item',function(e){
            e.preventDefault();
            selectMuseumType.setActiveType($(this).attr('data-slug'));
            selectType(selectMuseumType.activeType);
        });

        const selectType = (activeType) => {
            // clear all marks
            homePageMap.clearMarkers();
            // draw selected type marks
            const marks = homePageMap.marks.filter(mark => mark.type_slug === activeType);
            if(marks.length) {
                marks.forEach(mark=>{
                    homePageMap.drawMarker(mark);
                });
            }
            // fit map to marks
            homePageMap.fitMapToMarks();
        };

        /** click by info window title **/
        $('body').on('click','.js-click-title',function(e){
            e.preventDefault();
            const id = parseInt($(this).attr('data-id'),10);
            const mark = homePageMap.marks.filter(mark=>mark.id === id);

            if (mark.length) {
                $previewBox.empty();
                const {title, excerpt, id} = mark[0];
                const $previewHtml = `<h2 class="title">${title}</h2>
                                  <p class="text-el">${excerpt}</p>
                                  <div class="read_more_loction">
                                     <a class="js-click-read-more" data-id="${id}'" href="#">
                                        Mer om ${title}
                                     </a>
                                  </div>`;
                $previewBox.append($previewHtml);
                correctMapSectionHeight()
            }
            if(isTouchDev()) {
                $('html, body').animate({
                    scrollTop: $previewBox.offset().top,
                }, 200);
            }
        });
    };

    $('body').on('click','.js-click-read-more',function(e){
        e.preventDefault();
        const id = parseInt($(this).attr('data-id'),10);
        homeMarkInfoPopup.open(id);
    });

    $('body').on('click','.js-close-mark-popup-button',function(e){
        e.preventDefault();
        homeMarkInfoPopup.close();
    });

    // only in home page
    if ($('body').hasClass('home') || $('body').hasClass('page-template-g1')) {
        setTimeout(()=>{
            $(document).ready(initHomeMap);
        },0)
    }
};

// generate objects of markers for map
const generateMarkerObject = (mark) => {
    const { id, title, excerpt, latitude, longitude, type_slug } = mark;
    let markerObj = {
        id,
        coords: {
            lat: parseFloat(latitude),
            lng: parseFloat(longitude),
        },
        title,
        excerpt,
        type_slug,
    };
    if(isTouchDev()) {
        markerObj = {...markerObj, content:'<a class="info-window-title touch js-click-title" data-id="' + id + '" href="#">' + title + '</a>'}
    } else {
        markerObj = {...markerObj, content:'<a class="info-window-title js-click-title" data-id="' + id + '" href="#">' + title + '</a>'}
    }
    return markerObj;
};

// markers coordinates values validation
const isValidateMarkCoords = (mark) => {
    let isValidate = true;
    const { latitude, longitude } = mark;
    const latNumber = Number(latitude);
    const lonNumber = Number(longitude);
    if (isNaN(latNumber) || isNaN(lonNumber) || !latNumber || !lonNumber) {
        isValidate = false;
    }
    if (!isNaN(latNumber)) {
        if(latNumber > 90 || latNumber < -90) {
            isValidate = false;
        }
    }
    if (!isNaN(lonNumber)) {
        if(lonNumber > 180 || lonNumber < -180) {
            isValidate = false;
        }
    }
    return isValidate;
};

const getMapMarks = () => {
    return new Promise((resolve,reject)=>{
        // get all marks
        $.ajax({
            type : "GET",
            dataType : "json",
            url: window.ajaxurl,
            data: ({action: 'museum_markers_list_action'}),
            success: (res)=>{
                if(res.success) {
                    const { markers } = res;
                    let marks = [];
                    if(markers.length) {
                        markers.forEach(mark=>{
                            if(isValidateMarkCoords(mark)) {
                                marks.push(generateMarkerObject(mark));
                            }
                        });
                    }
                    resolve(marks);
                }
            },
            error: (error) => {
                reject(error);
            },
        });
    })
};

const getMarksTypes = () => {
    return new Promise((resolve,reject)=>{
        // get marks types
        $.ajax({
            type : "GET",
            dataType : "json",
            url: window.ajaxurl,
            data: ({action: 'museum_markers_types_action'}),
            success: (res)=>{
                if(res.success) {
                    const types = res.types.map(type => type.slug);
                    resolve(types);
                }
            },
            error: (error) => {
                reject(error);
            },
        });
    })
};



// WEBPACK FOOTER //
// ./scripts/modules/map.js